import useLenis from "@/hooks/useLenis";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Services } from "@/components/site/Services";
import { Manifesto } from "@/components/site/Manifesto";
import { Ribbon } from "@/components/site/Ribbon";
import { Portfolio } from "@/components/site/Portfolio";
import { Craftsmanship } from "@/components/site/Craftsmanship";
import { Reviews } from "@/components/site/Reviews";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export const MainSite = () => {
  useLenis();
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Services />
        <Manifesto />
        <Ribbon />
        <Portfolio />
        <Craftsmanship />
        <Reviews />
        <Contact />
      </main>
      <Footer />
    </>
  );
};
